module.exports = __webpack_public_path__ + "static/img/mo_icn_kakao@3x.77d530e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/mo_icn_kakao@3x.png
// module id = vsD3
// module chunks = 10